import MZLocation from '../../models/MZLocation'
import MZCApiService from '../mzcapi'

function fillMZLocationFromResponse ($store, response) {
  let data = response.data.data
  let meta = response.data.meta

  if (data.length === 0) {
    return
  }

  $store.state.total_pages = meta.pagination.total_pages

  let _myScrubData = data.map(responseLocation => {
    let item = {...responseLocation}

    item.coupons = responseLocation.coupons.data
    item.loyalty = responseLocation.loyalty.data

    return item
  })

  MZLocation.insert({
    data: _myScrubData
  })

  $store.state.current_page = meta.pagination.current_page
}

async function triggerSingleRequest ($store, page) {
  console.log('JW 7')
  console.log($store.state.coords)
  let locCoords = $store.state.coords
  if (!locCoords) {
    locCoords = $store.getters.appConfig.defaultCoords
  }

  let response = await MZCApiService.getFromConsumerStoreProfile({
    include: 'interestCategories,loyalty,coupons',
    page: page,
    per_page: 30
  }, locCoords, $store.getters.getToken)
  console.log('JW 8')

  fillMZLocationFromResponse($store, response)
  console.log('JW 9')
}

async function triggerSingleGuestRequest ($store, page) {
  let response = await MZCApiService.getFromConsumerGuestStore({
    include: 'interestCategories,loyalty,coupons',
    page: page,
    per_page: 30
  }, $store.state.coords, $store.getters.getToken)

  fillMZLocationFromResponse($store, response)
}

export default {
  async loadInitialData ($store) {
    console.log('JW 4')

    for (let page = 1; page <= $store.getters.appConfig.initialCachePages; ++page) {
      console.log('JW 5')

      if ($store.state.total_pages === -1 || $store.state.current_page < $store.state.total_pages) {
        console.log('JW 6')

        await triggerSingleRequest($store, page)
      }
    }
  },
  async loadInitialGuestData ($store) {
    for (let page = 1; page <= $store.getters.appConfig.initialCachePages; ++page) {
      if ($store.state.total_pages === -1 || $store.state.current_page < $store.state.total_pages) {
        await triggerSingleGuestRequest($store, page)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/mzlocation/index.js